module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('div', {
    staticClass: "menu",
    class: {
      "menu--family-fun-event": _vm.$route.path.includes("/mouth-guard-registration")
    }
  }, [_c('div', {
    staticClass: "menu__overlay"
  }, [_c('transition', {
    attrs: {
      "name": "title-fade"
    }
  }, [(!_vm.$store.state.menu && (_vm.$route.path != "/" && !_vm.$route.path.includes("/covid-19-updates") && !_vm.$route.path.includes("/virtual-services") && !_vm.$route.path.includes("/virtual-consultation") && !_vm.$route.path.includes("/7-and-up") && !_vm.$route.path.includes("/videos") && !_vm.$route.path.includes("/about-us"))) ? _c('div', {
    staticClass: "menu__title",
    class: {
      "menu__title--white": _vm.$route.path === "/treatments" || _vm.$route.path === "/mattiacio-difference", "menu__title--family-fun-event": _vm.$route.path.includes("/mouth-guard-registration")
    }
  }, [_vm._v(_vm._s(_vm.$route.name))]) : _vm._e()]), (_vm.$route.path.includes("/virtual-services")) ? _c('div', {
    staticClass: "menu__appt",
    class: {
      "menu__appt--is-visible": !_vm.$store.state.menu && _vm.$route.path != "/contact-us" && _vm.$route.path != "/", "menu__appt--white": _vm.$route.name != "Treatments"
    },
    on: {
      "click": _vm.makeAppt
    }
  }, [_c('span', [_vm._v("Make an Appointment")]), _c('Icon', {
    staticClass: "menu__appt-icon",
    attrs: {
      "name": "arrow"
    }
  })], 1) : _vm._e()], 1), _c('div', {
    staticClass: "menu__container",
    class: {
      "menu__mouth-guard": _vm.$route.path.includes("/mouth-guard-registration")
    }
  }, _vm._l((_vm.links), function(link, i) {
    return (link.navigation) ? _c('div', {
      key: i,
      staticClass: "menu__link-wrapper",
      class: {
        "active": _vm.$route.name === link.name && !_vm.$store.state.menu, "menu__link-wrapper--current": _vm.$route.name === link.name, "not-active": _vm.$route.name != link.name && _vm.$store.state.menu
      },
      style: (_vm.styleObject)
    }, [(link.name === "About Us") ? _c('div', {
      staticClass: "menu__link-container"
    }, [_c('video', {
      staticClass: "menu__link-video",
      attrs: {
        "loop": "loop",
        "muted": "muted",
        "autoplay": "autoplay"
      },
      domProps: {
        "muted": true
      }
    }, [_c('source', {
      attrs: {
        "src": _vm.props.acf.hero_video,
        "type": "video/mp4"
      }
    })]), _c('div', {
      staticClass: "menu__link-overlay"
    }), _c('div', {
      staticClass: "menu__link-expanded-overlay"
    }), _c('div', {
      staticClass: "menu__link",
      on: {
        "click": function($event) {
          return _vm.closeMenu(link)
        }
      }
    }, [_vm._v(_vm._s(link.name))]), (link.children) ? _c('div', {
      staticClass: "menu__submenu"
    }, _vm._l((link.children), function(item, i) {
      return _c('div', {
        key: i,
        staticClass: "menu__submenu-link",
        domProps: {
          "innerHTML": _vm._s(item.label)
        },
        on: {
          "click": function($event) {
            return _vm.closeMenu(item)
          }
        }
      })
    }), 0) : _vm._e()]) : _vm._e(), (link.name != "About Us") ? _c('div', {
      staticClass: "menu__link-container",
      class: {
        "menu__link-container--disabled": !_vm.$store.state.menu
      },
      style: ({
        backgroundImage: 'url(' + link.url + ')'
      })
    }, [_c('div', {
      staticClass: "menu__link-overlay"
    }), _c('div', {
      staticClass: "menu__link-expanded-overlay"
    }), _c('div', {
      staticClass: "menu__link",
      on: {
        "click": function($event) {
          return _vm.closeMenu(link)
        }
      }
    }, [_vm._v(_vm._s(link.name))]), (link.children) ? _c('div', {
      staticClass: "menu__submenu"
    }, [_vm._l((link.children), function(item, i) {
      return _c('div', {
        key: i,
        staticClass: "menu__submenu-link",
        domProps: {
          "innerHTML": _vm._s(item.label)
        },
        on: {
          "click": function($event) {
            return _vm.closeMenu(item)
          }
        }
      })
    }), _vm._l((link.children), function(item, i) {
      return (link.name === "Contact Us" || link.name === "New Patients") ? _c('a', {
        staticClass: "menu__submenu-link",
        attrs: {
          "href": item.path,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(item.item))]) : _vm._e()
    })], 2) : _vm._e()]) : _vm._e()]) : _vm._e()
  }), 0), _c('div', {
    staticClass: "menu__social-links",
    class: {
      "active": _vm.$store.state.menu
    }
  }, _vm._l((_vm.props.acf.social_links), function(link, i) {
    return _c('a', {
      staticClass: "menu__social-link",
      attrs: {
        "href": link.href,
        "target": "_blank"
      }
    }, [_c('Icon', {
      class: "menu__" + link.label,
      attrs: {
        "name": link.icon
      }
    })], 1)
  }), 0)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0cde8c3d","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/menu/menu.pug
// module id = 672
// module chunks = 1